// extracted by mini-css-extract-plugin
export default {"container":"ScrollToTop_container__+oTkI","svg":"ScrollToTop_svg__XNveP"};